import React, { useRef, useState } from 'react';
import css from './listMapping.module.scss';
import { NavLink } from "react-router-dom";
import ATable from '../../../Components/ATable/ATable';
import { consumed_from_pv, consumption_today, revenue_today, yield_today } from '../../../Images/Icons';
import SettingTable from '../../../Components/ATable/SettingTable';
import { getDataMappingGroup1,getDataMappingGroup2,getDataMappingGroup3,getDataMappingGroup4 } from '../../../Services/Admin/ListAdminServices';

const ListMappingPage = () => {
    const aTable = useRef();

    let columnsUser = [
        {title: "No", field: "no", align: "center", sortable: true},
        {title: "Station Code", field: "station_code", align: "left", sortable: true},
        {title: "email", field: "email", align: "left", sortable: true},
    ];
    const settingTable = {
        FilterSearchAll : true,
        filter:true, };


    const [TabSelected, setTabSelected] = useState(1);

    return (
        <div className='wrap_admin'>
            <div className='row vh-100'>
                <div className='col-md-12' style={{ maxHeight: '100vh', overflowY: 'auto', overflowX: 'hidden' }}>

                    <div className={`${css.content_position} row`}>
                        <div className={css.tab_wrap}>
                            <div className={`${css.tab} ${TabSelected === 1 ? css.active : ''}`} onClick={() => setTabSelected(1)}>Group 1</div>
                            <div className={`${css.tab} ${TabSelected === 2 ? css.active : ''}`} onClick={() => setTabSelected(2)}>Group 2</div>
                            <div className={`${css.tab} ${TabSelected === 3 ? css.active : ''}`} onClick={() => setTabSelected(3)}>Group 3</div>
                            <div className={`${css.tab} ${TabSelected === 4 ? css.active : ''}`} onClick={() => setTabSelected(4)}>Group 4</div>
                        </div>
                    </div>
                    <div className={`${css.content_position_table} row`} style={{ marginBottom: 100 }}>
                        {TabSelected === 1 && <SettingTable columns={columnsUser} data={getDataMappingGroup1} {...settingTable} changeTab={1} />  }  
                        {TabSelected === 2 && <SettingTable columns={columnsUser} data={getDataMappingGroup2} {...settingTable} changeTab={2} />  }  
                        {TabSelected === 3 && <SettingTable columns={columnsUser} data={getDataMappingGroup3} {...settingTable} changeTab={3} />  }  
                        {TabSelected === 4 && <SettingTable columns={columnsUser} data={getDataMappingGroup4} {...settingTable} changeTab={4} />  }  
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ListMappingPage;
